<template>
	<div class="ct-group">
		<div class="ct-group-controls">
			<a href="#" :uk-toggle="'target: #' + modalId" class="standard-text" @click="clearGroup">
				<i class="fas fa-plus-circle"></i> Add Group
			</a>
		</div>
		<div class="uk-width-1-2@l uk-width-1-1@m">
			<data-table
				v-if="isForCertification"
				ref="cert_group_table"
				:searchable="false"
				api_point="cert-groups/list"
				search_placeholder=""
				:use_actions="false"
				:table_headers="{
					name:{display:'Certification Groups'},
					id:{display:'', sortable:false, buttons:[
						{faClass:'far fa-edit', event:'edit'},
						{faClass:'far fa-trash-alt', event:'delete'}
					]}
				}"
				@edit="editGroup"
				@delete="deleteGroup"
			></data-table>
			<data-table
				v-else
				ref="cert_group_table"
				:searchable="false"
				api_point="train-groups/list"
				search_placeholder=""
				:use_actions="false"
				:table_headers="{
					name:{display:'Training Groups'},
					id:{display:'', sortable:false, buttons:[
						{faClass:'far fa-edit', event:'edit'},
						{faClass:'far fa-trash-alt', event:'delete'}
					]}
				}"
				@edit="editGroup"
				@delete="deleteGroup"
			></data-table>
		</div>
		<div :id="modalId" ref="groupModal" uk-modal class="ct-group-modal">
			<div class="uk-modal-dialog uk-modal-dialog-large uk-modal-body" style="width: auto;">
				<div class="uk-grid">
					<div class="uk-width-1-2@m">
						<label for="ct-group-name" class="uk-form-label">Name</label>
						<div class="uk-form-controls">
							<input id="ct-group-name" type="text" class="uk-input" placeholder="Group Name" v-model="group.name"  />
							<div v-if="false" class="uk-form-help-block uk-text-danger">
								<strong>Please include a name</strong>
							</div>
						</div>
						<div class="data-table">
							<table cellspacing="0" cellpadding="0">
								<thead>
								<tr>
									<th class="">
										<span>{{ isForCertification ? "Certification":"Training" }}</span>
									</th>
								</tr>
								</thead>
								<tbody>
								<tr v-for="item in group.items" class="">
									<td class="" sorted="true"><span>{{ item.name }}</span></td>
									<td class="">
										<button style="background: none; border: none;" @click="removeItem(item.id)">
											<i class="fas fa-times"></i>
										</button>
									</td>
								</tr>
								</tbody>
							</table>
						</div>
						<button type="button" class="uk-button uk-button-primary" @click="updateGroup">Save</button>
					</div>
					<div class="uk-width-1-2@m">
						<data-table
							v-if="isForCertification"
							ref="cert_table"
							:searchable="true"
							api_point="certs/list"
							search_placeholder=""
							:use_actions="false"
							:per_page="15"
							:table_headers="{
								name:{display:'Certification'},
								id:{display:'', sortable:false, buttons:[
									{faClass:'fas fa-plus', event:'add'}
								]}
							}"
							@add="addItem"
						></data-table>
						<data-table
							v-else
							ref="cert_table"
							:searchable="true"
							api_point="training/list"
							search_placeholder=""
							:use_actions="false"
							:per_page="15"
							:table_headers="{
								name:{display:'Training'},
								id:{display:'', sortable:false, buttons:[
									{faClass:'fas fa-plus', event:'add'}
								]}
							}"
							@add="addItem"
						></data-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DataTable from "../Table/DataTable.vue";
export default {
	name: "CtGroup",

	props: {
		groupType:{
			type: String, //must be either "cert" or "train"
			default: "cert"
		}
	},
	components:{
		DataTable
	},
	data() {
		return {
			group:{
				name:"",
				items:[]
			},
			modalId:""
		}
	},
	mounted(){
		this.modalId = "ct-" + this.groupType + "-modal";
	},
	methods: {
        clearGroup(){
            this.group = {
                name:"",
                items:[]
            }
		},
		addItem(id){
			if(this.isForCertification){
				axios.get("api/certs/get/" + id)
					.then((pack) => this.pushItem(pack))
					.catch(() => {console.warn("Unable to get item.");})
			} else {
                axios.get("api/training/get/" + id)
                    .then((pack) => this.pushItem(pack))
                    .catch(() => {console.warn("Unable to get item.");})
			}
		},
		editGroup(id){
			if(this.isForCertification){
                axios.get("api/cert-groups/get/" + id).then(
                    (pack) => this.loadGroup(pack)
				).catch(
                    () => {}
				)
			} else {
                axios.get("api/train-groups/get/" + id).then(
                    (pack) => this.loadGroup(pack)
                ).catch(
                    () => {}
                )
			}
		},
		loadGroup(pack){
            if(pack.data && pack.data.data){
                this.group = pack.data.data;
                this.$forceUpdate();
                UIkit.modal(this.$refs.groupModal).show();
			}
		},
		removeItem(id){
            for(let i = 0; i < this.group.items.length;++i){
                if(this.group.items[i].id == id){
                    this.group.items.splice(i, 1);
                    return;
				}
			}
		},
		deleteGroup(id){
            UIkit.modal.confirm("Are you sure you want to delete this group?").then(() => {
                if(this.isForCertification){
                    axios.post("api/cert-groups/delete/" + id).then(
                        (pack) => this.reloadGroups(pack)
                    ).catch(
                        () => {}
                    )
                } else {
                    axios.post("api/train-groups/delete/" + id).then(
                        (pack) => this.reloadGroups(pack)
                    ).catch(
                        () => {}
                    )
                }
			});
		},
		reloadGroups(){
            this.$refs.cert_group_table.searchTable();
		},
		pushItem(pack){
			if(pack.data && pack.data.data){
				this.group.items.push(pack.data.data);
				this.$forceUpdate();
			}
		},
		updateGroup(){
			if(this.isForCertification){ //certification group
                if(!this.group.id){
                    axios.post("api/cert-groups/save", this.group).then(
                        () => this.groupUpdated()
                    ).catch(
                        () => {/*nothing for now*/}
                    )
				} else {
                    axios.post("api/cert-groups/save/" + this.group.id, this.group).then(
                        () => this.groupUpdated()
                    ).catch(
                        () => {/*nothing for now*/}
                    )
				}
			} else { //training group
                if(!this.group.id){
                    axios.post("api/train-groups/save", this.group).then(
                        () => this.groupUpdated()
                    ).catch(
                        () => {/*nothing for now*/}
                    )
                } else {
                    axios.post("api/train-groups/save/" + this.group.id, this.group).then(
                        () => this.groupUpdated()
                    ).catch(
                        () => {/*nothing for now*/}
                    )
                }
			}

		},
		groupUpdated(){
            UIkit.modal.alert("The group has been updated.");
            this.reloadGroups();
		}
	},
	watch:{},
	computed:{
		isForCertification(){
			return this.groupType == "cert";
		}
	}
}
</script>

